import React, { useState, useContext } from 'react'
import ReviewSlider from './reviewSlider'
import CalculatorContext from '../Context'
import Button from './button'
import {useHistory} from 'react-router-dom';


function Review() {  
  const history = useHistory();
  const context = useContext(CalculatorContext)
  const {coal, smartphone, amount, price, percent} = context;

  return (
    <div>
      <div className="smallInstructions">
        {window.calculator_options.is_big_sky?(
        <div>          
          Make your trip to Big Sky Resort carbon neutral by offsetting 100% or more of
          your calculated emissions below. Your decision to offset enables Tradewater
          to collect and destroy potent greenhouse gases all over the world.
        </div>
        ):(
          <div>
            Make your trip carbon neutral by offsetting 100% or more of
          your calculated emissions below. Your decision to offset enables Tradewater
          to collect and destroy potent greenhouse gases all over the world.
          </div>
        )}
        <ReviewSlider />
        {window.calculator_options.is_big_sky?(
        <div className="review-summary">
          The {(Number(amount) / price).toFixed(2)} tons of emissions from your trip to Big Sky Resort are equivalent to:
        </div>
        ):(
          <div className="review-summary">
          The {(Number(amount) / price).toFixed(2)} tons of emissions from your trip are equivalent to:
        </div>)}
        <div className="final-back">
          <div className="tags">           
            <div className="tag">
              <img className="battery" src="/wp-content/themes/tradewater/dist/widget/images/battery.svg" alt="battery"/>
              <span>{smartphone}</span> Smartphones charged
            </div>
            <div className="tag">
              <img className="fire" src="/wp-content/themes/tradewater/dist/widget/images/fire.svg" alt="battery"/>
              <span>{coal}</span> Pounds of coal burned
            </div>          
          </div>
          
        </div>
      </div>
    </div>

  )


}


export default Review